import { InsuranceMonitorConfiguration } from "@wingspanhq/wingspan-api-sdk";

/**
 * The policy types a monitor configuration requires, as wire values — the
 * configuration-shaped twin of `selectorPolicyTypesFromMonitor`, for callers
 * holding the configuration a requirement definition points at rather than a
 * monitor.
 */
export const selectorPolicyTypesFromSettings = (
  insuranceMonitorConfiguration?: InsuranceMonitorConfiguration
) =>
  insuranceMonitorConfiguration?.coverages?.map(
    coverage => coverage.policyType
  );
